import React, {useEffect, useState} from "react";
import {
    Box,
    Card,
    CardContent,
    Grid,
    Typography
} from '@deere/fuel-react';
import TrendingDownIcon from "@material-ui/icons/TrendingDown";
import {
    DECREASE,
    INCREASE,
    SPECIAL_AWARDS,
    SPEND_IN_MILLION,
    SPEND_ROLLING_CARD_TITLE
} from "../shared/Constants";
import TrendingUpIcon from "@material-ui/icons/TrendingUp";
import { SpecialAwards } from "./SpecialAwards";

export const RatingsSpendCard = ({supplierNumber, spendData}) => {
    const [ratingSpendTrend, setRatingSpendTrend] = useState(DECREASE);
    const [spendChangePercent, setSpendChangePercent] = useState("");
    const [totalSpendAmount, setTotalSpendAmount] = useState("");

    useEffect(() => {
        const rolling12PeriodObject = spendData.filter(item => item.days === "365")[0]
        const rolling24PeriodObject = spendData.filter(item => item.days === "730")[0]

        if(rolling24PeriodObject && rolling12PeriodObject) {
            const originalAmount = rolling24PeriodObject.usPymtAmt - rolling12PeriodObject.usPymtAmt;
            const decreaseAmount = originalAmount - rolling12PeriodObject.usPymtAmt;
            const percentDecrease = (decreaseAmount === 0 && originalAmount === 0) ? 0 : (decreaseAmount/originalAmount) * 100

            setRatingSpendTrend(percentDecrease >= 0 ? DECREASE : INCREASE)
            setSpendChangePercent(Math.abs(percentDecrease).toFixed(2))
        }

        rolling12PeriodObject && setTotalSpendAmount(Math.round(rolling12PeriodObject.usPymtAmt).toLocaleString())

        return () => {
            setRatingSpendTrend("")
            setSpendChangePercent("")
            setTotalSpendAmount("")
        } // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [spendData]);

    return (
        <Grid item xs={4}>
            <Box p={2}>
                <Card>
                    <CardContent>
                        <Typography variant="h4">{SPEND_ROLLING_CARD_TITLE}</Typography>
                        <Typography color="tertiary" size="sm">{SPEND_IN_MILLION}</Typography>
                        <Box pt={3} pb={3}>
                            <Typography size="4xl" fontWeight="bold">${totalSpendAmount}</Typography>
                        </Box>
                        <Typography color="tertiary" size="sm">
                            {ratingSpendTrend} from previous period {spendChangePercent}%
                            {ratingSpendTrend === INCREASE ?
                                <TrendingUpIcon
                                    fontSize="small"
                                    style={{marginLeft: ".25rem", color: "#367c2b"}}
                                />
                                :
                                <TrendingDownIcon fontSize="small"
                                                  style={{marginLeft: ".25rem", color: "#c21020"}}/>
                            }
                        </Typography>
                    </CardContent>
                </Card>
            </Box>
            <Box p={2}>
                <Card>
                    <CardContent style={{height: '173px'}}>
                        <Typography variant="h4">{SPECIAL_AWARDS}</Typography>
                        <SpecialAwards supplierNumber={supplierNumber}/>
                    </CardContent>
                </Card>
            </Box>
        </Grid>
    )
}
